import {connect} from 'react-redux';
import {DepositSolution as Component} from './DepositSolution';
import {
  showModal,
  incSolution,
  decSolution
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    solutions: state.notebook.protocolSection.scene.apparatus.solutions,
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    incSolution: (data) => {
      dispatch(incSolution(data))
    },
    decSolution: (data) => {
      dispatch(decSolution(data))
    }
  };
}

export const DepositSolution = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
